export default __webpack_public_path__ + "static/media/ThirdBoxIconV2.218d470b.svg";